var Keys = {
  escape: 27
};

export default Keys;